export default "assets/images/logo2-db5a6484.png";